import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface TimeSheetApprovalDetailsFeedbackPageState {
    approval: boolean
    edit: boolean
    noApproval: boolean
    error: boolean
  }

const initialState: TimeSheetApprovalDetailsFeedbackPageState = {
    approval: false,
    edit: false,
    noApproval: false,
    error: false
}
export const timesheetApprovalFeedbackDetailsSlice = createSlice({
    name: 'timesheetApprovalFeedbackDetails',
    initialState,
    reducers: {
      approvalChange: (state, action: PayloadAction<TimeSheetApprovalDetailsFeedbackPageState>) => {
        state.approval = action.payload.approval
        state.edit = action.payload.edit
        state.noApproval = action.payload.noApproval
        state.error = action.payload.error
      }
    }
});

export const { approvalChange } = timesheetApprovalFeedbackDetailsSlice.actions